export const VERIFICATION_OPTIONS = [
  { id: 'valid', label: 'valid' },
  { id: 'risky', label: 'risky' },
  { id: 'invalid', label: 'invalid' },
];

export const CLASSIFICATION_OPTIONS = [
  { id: 'Direct Personal', label: 'direct' },
  { id: 'Direct Personal Variant', label: 'direct variant' },
  { id: 'Role-Personal Hybrid', label: 'role-personal' },
  { id: 'Team Functional', label: 'team' },
  { id: 'High-Signal Generic', label: 'high-signal' },
  { id: 'Standard Generic', label: 'generic' },
  { id: 'Sales Alias', label: 'sales' },
  { id: 'Ops / Customer-Facing', label: 'ops' },
  { id: 'Back Office / Non-Revenue', label: 'back office' },
  { id: 'Corporate / PR / Restricted', label: 'corporate' },
  { id: 'Unknown', label: 'unknown' },
];

export const DEFAULT_EMAIL_FILTERS = {
  verifications: VERIFICATION_OPTIONS.map((o) => o.id),
  classifications: CLASSIFICATION_OPTIONS.map((o) => o.id),
};

export function matchesEmailFilters(row, filters, isDomainHiddenFn, isEmailHiddenFn) {
  if (!row) return false;
  if (isDomainHiddenFn?.(row.domain)) return false;
  if (isEmailHiddenFn?.(row.email)) return false;
  const v = (row.verification || 'invalid').toLowerCase();
  const c = row.classification || 'Unknown';
  const verifications = filters?.verifications || [];
  const classifications = filters?.classifications || [];
  return verifications.includes(v) && classifications.includes(c);
}
